module.exports = __webpack_public_path__ + "static/TransparentPricing-080c18446e8379895d12eac1509f3dbc.png";